export default "__VITE_PUBLIC_ASSET__34d81469__"